import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { FORGOT_PASSWORD } from 'redux/sagas/actions/authentication';
import { FORGOT_STEPS } from 'redux/slices/authentication';

import routes from '../../routing/routes';

import ChangePassword from './changePassword';
import ForgotPasswordWrapper from './forgotPassword';
import PasswordSuccessPage from './passwordSuccess';

const ForgotPassword = ({ forgotStep, forgotPassword, error, forgotData }) => {
  const history = useHistory();
  useEffect(() => {
    if (forgotStep === FORGOT_STEPS.empty) {
      history.push(routes.signin.path);
    }
  }, [forgotStep, history]);

  const resetForgotPasswordKeyboard = (e, email) => {
    if (e?.key === 'Enter') {
      forgotPassword(email);
    }
  };

  const resetForgotPassword = email => {
    forgotPassword(email);
  };

  return (
    <>
      {/*<ErrorWrapper>
        {error && <MainFont type="errorLabel">{error}</MainFont>}
      </ErrorWrapper>*/}
      {forgotStep === FORGOT_STEPS.forgotPassword ? (
        <ForgotPasswordWrapper
          error={error}
          resetForgotPassword={resetForgotPassword}
          resetForgotPasswordKeyboard={resetForgotPasswordKeyboard}
        />
      ) : null}
      {forgotStep === FORGOT_STEPS.changePassword ? (
        <ChangePassword
          error={error}
          resendVerificationCode={() => forgotPassword(forgotData.userName)}
        />
      ) : null}
      {forgotStep === FORGOT_STEPS.newPasswordSuccess && (
        <PasswordSuccessPage />
      )}
    </>
  );
};

ForgotPassword.propTypes = {
  forgotStep: PropTypes.string,
  forgotPassword: PropTypes.func.isRequired,
  error: PropTypes.string,
  forgotData: PropTypes.object
};

export default connect(
  ({ authentication }) => ({
    forgotStep: authentication.forgotStep,
    error: authentication.errorMessage,
    forgotData: authentication.forgotData
  }),
  dispatch => ({
    forgotPassword: payload =>
      dispatch({ type: FORGOT_PASSWORD._REQUEST, payload })
  })
)(ForgotPassword);
